import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
  RemoveFromTrashBinDocument,
  RemoveFromTrashBinMutation,
  RemoveFromTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRemoveFromTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const client = useApolloClient()
  const [removeDocumentsFromTrashBin, { loading }] = useMutation(RemoveFromTrashBinDocument, {
    extractorFn: (data: RemoveFromTrashBinMutation) =>
      data.documentsMutations.removeFromTrashBinDocumentsDocument,
  })

  return {
    loading,
    async removeDocumentsFromTrashBin(variables: RemoveFromTrashBinMutationVariables) {
      const result = await removeDocumentsFromTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useRemoveFromTrashBinDocument
